import { SvgFactory } from '../../Svg';

const UserAvatarIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80' fill='black'>
        <path d='M39.9997 40C47.3663 40 53.333 34.0333 53.333 26.6666C53.333 19.3 47.3663 13.3333 39.9997 13.3333C32.633 13.3333 26.6663 19.3 26.6663 26.6666C26.6663 34.0333 32.633 40 39.9997 40ZM39.9997 46.6666C31.0997 46.6666 13.333 51.1333 13.333 60V63.3333C13.333 65.1666 14.833 66.6666 16.6663 66.6666H63.333C65.1663 66.6666 66.6663 65.1666 66.6663 63.3333V60C66.6663 51.1333 48.8997 46.6666 39.9997 46.6666Z' />
    </svg>,
);
export default UserAvatarIcon;
